import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { EventsPerspective, EventTimelineData, UseEventBarChartParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { getNcFileTimesConfig } from '@helpers';
import { secondsToInputDisplay } from '@v2/helpers/time';
import { HARDCODED_MAX_TIME_FOR_MACHINE_EVENTS } from '@v2/pages/common/components/NCFileBatchEvents/constants';
import { useSelector } from 'react-redux';
import { selectSingleBatch } from '@reducers/batch';
import { ProductionBatchStatistics } from '@interfaces/search';
import { getNcFileTimeValues, getBatchTimeValues, getEventDurations } from '@v2/pages/common/components/NCFileBatchEvents/helpers';

export const useEventBarChart = ({ events, eventType, ncFileStatistics, eventsPerspective }: UseEventBarChartParams) => {
  const batchData: ProductionBatchStatistics | null = useSelector(selectSingleBatch);

  const ncFilePerspective = eventsPerspective === EventsPerspective.NC_FILE;
  const machinesPerspective = eventsPerspective === EventsPerspective.SINGLE_MACHINE || eventsPerspective === EventsPerspective.MULTI_MACHINES;

  let barChartData: EventTimelineData[] = [];

  if (!events.length || eventType === NcFileBatchEventType.TRACE) {
    return { barChartData };
  }

  const ncFileTimesConfig = ncFilePerspective
    ? getNcFileTimesConfig({ data: ncFileStatistics, secondsToInputDisplay, shouldConvertSecToDisplay: false })
    : null;

  const timeValues = ncFilePerspective
    ? getNcFileTimeValues(ncFileTimesConfig!, ncFileStatistics, eventType)
    : getBatchTimeValues(batchData, eventType);

  // Apply machine perspective max time override
  const maxTimeInSec = machinesPerspective ? HARDCODED_MAX_TIME_FOR_MACHINE_EVENTS : timeValues.maxTimeInSec;

  if (maxTimeInSec <= 0) {
    return { barChartData };
  }

  barChartData = events.map((event) => ({
    ...getEventDurations(event, eventType),
    ...timeValues,
    maxTimeInSec,
    showDots: true,
  }));

  return { barChartData };
};
